import React from 'react'
import Decimal from 'decimal.js'

import { formatPrice } from 'utils/currency'
import {
  ButtonSection as Button,
  ButtonLabel,
  OrderNumber,
  Price,
  PriceContainer,
  OriginalPrice,
  DiscountedPrice,
} from './styled'

import withAnalytics from 'enhancers/withAnalytics'
import events from 'const/analytics-events'
import { compose } from 'recompose'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { isWhiteLabel } from 'utils/whiteLabel'
import { isMultiVendor } from 'utils/multiVendor'
import { getQueryParams } from 'utils/url'
import get from 'lodash/get'

const ButtonSection = withAnalytics()(Button)

const ViewOrder = ({
  orderQuantity,
  orderPrice,
  orderFees,
  orderDiscount,
  goToOrder,
  match,
  isGfoOrder,
}) => (
  <ButtonSection
    onClick={goToOrder}
    analytics={[
      {
        eventType: 'onClick',
        options: {
          ...events['MENU_CLICK_GO_TO_CHECKOUT'],
          label: String(match.params.id),
          ...(isGfoOrder && {
            gfo_order: true,
          }),
        },
      },
    ]}
  >
    {orderQuantity > 0 && (
      <OrderNumber small>
        <span>{orderQuantity}</span>
      </OrderNumber>
    )}
    <ButtonLabel>Review order</ButtonLabel>
    {orderPrice > 0 && orderDiscount < 0 ? (
      <PriceContainer>
        <OriginalPrice>
          {formatPrice(new Decimal(orderPrice).plus(orderFees || 0))}
        </OriginalPrice>
        <DiscountedPrice>
          {formatPrice(
            new Decimal(orderPrice).plus(orderDiscount).plus(orderFees || 0),
          )}
        </DiscountedPrice>
      </PriceContainer>
    ) : orderPrice > 0 ? (
      <Price>{formatPrice(new Decimal(orderPrice).plus(orderFees || 0))}</Price>
    ) : (
      <div />
    )}
  </ButtonSection>
)

export default compose(
  withRouter,
  connect((state, props) => {
    const qstr = getQueryParams(get(props, 'history.location.search'))
    return {
      isGfoOrder:
        !(isMultiVendor() || isWhiteLabel()) &&
        get(qstr, 'channel') === 'gfo_redirect',
    }
  }),
)(ViewOrder)
